import React from 'react';
import styles from './setting.module.css'
import {Link} from 'react-router-dom'
import {CgProfile} from 'react-icons/cg'
import {FiEdit} from 'react-icons/fi'
import {BsShieldLock} from 'react-icons/bs'
import {AiOutlineBell,AiOutlineMessage,AiOutlineInteraction} from 'react-icons/ai'
import {IoLanguage} from 'react-icons/io5'
import {useRouteMatch} from 'react-router-dom'

const SettingList=()=>{

    const { path } = useRouteMatch()



    return(
        <div className={styles.settingListCon}>
            <Link className={styles.linkitem} to={`${path}/profile`} >
           <CgProfile style={{marginRight:"10px"}}/>
           Profile Setting       
           </Link>
           <Link className={styles.linkitem} to={`${path}/edit-profile`} >
           <FiEdit style={{marginRight:"10px"}}/>
           Edit Profile       
           </Link>
           <Link className={styles.linkitem} to={`${path}/privacy`}>
           <BsShieldLock style={{marginRight:"10px"}}/>
           Privacy Setting         
           </Link>
           <Link className={styles.linkitem} to={`${path}/notification`}>
           <AiOutlineBell style={{marginRight:"10px"}}/>
           Notification Setting         
           </Link>
           <Link className={styles.linkitem} to={`${path}/message`}>
           <AiOutlineMessage style={{marginRight:"10px"}}/>
           Meassage Setting        
           </Link>
           <Link className={styles.linkitem} to={`${path}/activity`}>
           <AiOutlineInteraction style={{marginRight:"10px"}}/>
           Activity Setting        
           </Link>
           <Link className={styles.linkitem} to={`${path}/language`}>
           <IoLanguage style={{marginRight:"10px"}}/>
           Language Setting        
           </Link>
       
            
        </div>
    )
}

export default SettingList